<template>
  <div @click="onClick" v-click-outside="externalClick" class="text-area-main">
    <label
      ref="label"
      :class="{
        'label-focus': labelFocusFlag,
        'textarea-label': !labelFocusFlag,
      }"
    >
      {{ label }}
    </label>
    <span v-if="error" class="error-text padding-left-16" >{{ error }}</span>

    <textarea 
     :style="[
          width ? 'width:' + width : '',
          error ? borderColorRed : '',
          disabled ? borderColorDisabled : '',
        ]"
         :class="[
          icon
            ? border
              ? ' form-control default-settings has-error padding'
              : ' form-control default-settings has-error padding'
            : border
            ? ' form-control default-settings has-error'
            : ' form-control default-settings has-error',
        ]"
      :id="id"
      :value="modelValue"
      ref="textarea"
      v-on:input="updateValue($event.target.value)"
      type="textarea"
      :cols="columns"
      :rows="rows"
      
      :name="label"
      :readonly="readonly"
      :required="required"
      :disabled="disable"
      :maxlength="maxlength"
      @focus="focus"
      @blur="blur"
    />

    <div
      :id="countId"
      ref="hint"
      v-if="labelFocusFlag && count"
      class="hint-text"
    >
      {{ getCount() }}
    </div>
  </div>
</template>

<script>
export default {
  name: "STextarea",

  data() {
    return {
      modelValue: "",
      labelFocusFlag: false,
      id: "textarea" + this._uid,
      countId: "count" + this._uid,
      mounted: false,
      placeholder: String,
      cCount: 10,
       borderColorRed: {
        "border-color": "var( --text-error-color)",
        outline: "none",
        "box-shadow": "none",
      },
    };
    
  },

  props: {
    columns: {
      type: Number,
      default: 20,
    },
    rows: {
      type: Number,
      default: 5,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    /**
     * Optional max input length
     */
    maxlength: {
      type: Number,
    },

    count: {
      type: Boolean,
      default: false,
    },

    error: {
      type: String,
      
    },
    disabled: Boolean,
     icon: String,
      width: {},
      border: { type: Boolean, default: true },
  },

  watch: {
    value: function (nv, ov) {
      this.modelValue = nv;
      this.cCount = nv.length;
      //   console.log(nv.length)
    },
  },

  beforeDestroy() {
    // document.getElementById(this.id).removeEventListener('resize', this.handleResize);
    // window.removeEventListener("mouseup");
  },

  computed: {},

  mounted() {
    
    
    var element = document.getElementById(this.id);

    element.addEventListener("keypress", () => {
      this.value == "" ? (this.labelFocusFlag = true) : "";
    });
    

    if (this.value.length > 0) {
      this.labelFocusFlag = true;
    }

    if (this.maxlength < this.value.length) {
      this.modelValue = this.value.slice(0, this.maxlength);
      // console.log(this.value.slice(0,this.maxlength))
    } else {
      this.modelValue = this.value;
    }
  },

  updated() {
    // console.log("updated")
    if (document.querySelector("#" + this.countId)) {
      document.querySelector("#" + this.countId).style.marginLeft =
        this.$refs.textarea.clientWidth -
        (this.$refs.hint.clientWidth + 16) +
        "px";

      if (this.value.length > 0) {
        this.labelFocusFlag = true;
        let element = document.getElementById(this.id);
        element.scrollTop = element.scrollHeight;
      }

      this.textareaResize(
        document.querySelector("#" + this.id),
        document.querySelector("#" + this.countId)
      );
    }
  },

  methods: {
    
    onClick() {
      // console.log(this.labelFocusFlag);
      this.labelFocusFlag = true;
      var element = document.getElementById(this.id);
      element.focus();

      // WE WON'T BE NEEDING IT BCZ WHEN A CLICK IS REGISTERED ALL WE NEED TO DO IS TO FOCUS THE TEXTAREA
      // if(this.value){
      // 	this.labelFocusFlag = true;
      // }
      // else if(this.value == ""){
      // 	this.labelFocusFlag = !this.labelFocusFlag;
      // }
      // else {
      // 	this.labelFocusFlag = false;
      // }
      
    },
 focus() {
      if (!this.border) {
        this.$refs.label.className = "label-focus-no-bordered";
      }
      if (this.type === "datePicker" && !this.disabled) {
        if (!this.border) {
          this.$refs.label.className = "label-focus-no-bordered";
        } else {
          this.$refs.label.className = "label-focus";
        }
      }
      if ((this.readonly || this.disabled) && this.value) {
        // return;
        this.$refs.label.className = "label-focus";
      }
      if (this.border) {
        this.$refs.label.className = "label-focus";
      }
    },

   blur() {
      let value = this.$refs.textarea.value;
      value || this.placeholder
        ? this.border
          ? (this.$refs.label.className = "label-focus")
          : (this.$refs.label.className = "label-focus-no-bordered")
        : this.icon
        ? (this.$refs.label.className = "padding-left-24")
        : (this.$refs.label.className = "");
    },
    externalClick(event) {
      if (this.value == "") {
        this.labelFocusFlag = false;
      } else if (this.value) {
        this.labelFocusFlag = true;
      }
    },

    updateValue: function (value) {
      this.$emit("input", value);
    },

    getCount() {
      this.cCount = this.modelValue.length;
      if (this.maxlength) {
        return `Character Count : ${this.cCount}/${this.maxlength}`;
      } else {
        return `Character Count : ${this.cCount}`;
      }
    },

    textareaResize(source, dest) {
      var resizeInt = null;
      // console.log(source, dest)
      if (dest === null) {
        dest = document.querySelector("#" + this.countId);
      }

      // the handler function
      var resizeEvent = function () {
        dest.style.marginLeft =
          source.clientWidth - (dest.clientWidth + 16) + "px";
      };

      // This provides a "real-time" (actually 15 fps)
      // event, while resizing.
      // Unfortunately, mousedown is not fired on Chrome when
      // clicking on the resize area, so the real-time effect
      // does not work under Chrome.
      source.addEventListener("mousedown", function (e) {
        resizeInt = setInterval(resizeEvent, 1000 / 15);
      });

      // The mouseup event stops the interval,
      // then call the resize event one last time.
      // We listen for the whole window because in some cases,
      // the mouse pointer may be on the outside of the textarea.
      window.addEventListener("mouseup", function (e) {
        if (resizeInt !== null) {
          clearInterval(resizeInt);
        }
        resizeEvent();
      });
    },
  },
  
};
</script>

<style scoped>
.text-area-main {
  position: relative;
}
.default-settings{
	font-family: 'Roboto';
	width: -webkit-fill-available;
}

/* textarea{
	border: none;
	resize: none;
}

textarea:focus{
	outline: none;
} */

.label-focus {
  margin-top: -4px;
  margin-left: 8px;
  padding-right: 8px;
  padding-left: 8px;
  background-color: #fff;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.25;
  color: var(--black);
  text-transform: uppercase !important;
}
.label-focus-no-bordered {
  background-color: #fff;
  margin-top: -8px;
  margin-left: 8px;
  padding-right: 8px;
  padding-left: 8px;
    font-family: "Roboto !important";
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: var(--black);
  text-transform: uppercase !important;
}
.textarea-label {
  position: absolute;
  font-size: 14px !important;
  line-height: 1;
  margin-top: 14px;
  margin-left: 16px;
  cursor: pointer;
  color: var(--brown-grey);
  text-transform: capitalize;
}
/* .label-focus-no-bordered {
  background-color: #fff;
  margin-top: -8px;
  margin-left: 8px;
  padding-right: 8px;
  padding-left: 8px;
    font-family: "Roboto !important";
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: var(--black);
  text-transform: uppercase !important;
} */

.hint-text {
  position: relative;
  width: fit-content;
  background-color: #fff;
  font-size: 8px;
  line-height: 1.67;
  margin-top: -14px;
  margin-left: 16px;

  /* z-index: 10; */
}

.has-error:focus {
  border-color: ( --text-error-color)var !important;
  -webkit-box-shadow: none!important;
  box-shadow: none!important;
}

.form-control:focus {
  border-color: #66afe9 ;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6) ;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6)!important ;
}
label {
  /* text-transform: capitalize !important; THE CASE WAS NOT BEING CHANGED ON FOCUS SO COMMENTED IT ALSO RESPECTIVE CLASSES HAD  THEIR OWN RULE FOR THIS FUNCTIONALITY */
}

/* .error-text {
  position: absolute;
    font-family: "Roboto !important";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  margin-left: 16px;
  letter-spacing: normal;
  color: var(--text-error-color);
  padding-top: 120px;
} */
.error-text {
  position: absolute;
    font-family: "Roboto !important";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  padding-top: 120px;
  color: #ff0000;
  text-transform: capitalize;
}
 .has-error:focus {
  border-color: #ff0000 ;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 0, 0, 0) ;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 0, 0, 0)!important ;
}
.padding-left-40 {
  padding-left: 40px;
}
</style>